module.exports = __webpack_public_path__ + "img/KGS.111ca928.svg";